// @flow

import * as React from "react";

const RenderHTML = (props: {
    markup: string,
    dont_replace?: boolean,
}): React.Node => {
    const { markup = "", dont_replace, ...remainingProps } = props;
    if (markup && markup.replace) {
        return (
            <div
                {...remainingProps}
                dangerouslySetInnerHTML={{
                    __html: dont_replace ? markup : markup.replace(/\\"/g, '"'),
                }}
            ></div>
        );
    }
    return null;
};

export default RenderHTML;
